// extracted by mini-css-extract-plugin
module.exports = {"result":"ErrorPage_result__26U9S","image":"ErrorPage_image__O0yfZ"};